import { Component, Input, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Creneau, Jours } from 'src/app/model/creneau';
import { Context } from 'src/app/model/context';

@Component({
  selector: 'app-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.css'],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]],
  }]
})
export class PlanningComponent {  
  @Input() planning: Creneau[];
  @Input() context: Context;

  roundTimes(value: string, c: Creneau, mode: string) {
    let tmp = parseInt(value.substring(3));
    if (tmp % 15 > 7) {
      tmp = tmp + (15 - tmp % 15);
    } else {
      tmp = tmp - tmp % 15;
    }
    let time = value.substring(0,2) + ":" + (tmp < 10 ? '0':'') + tmp;

    
    if (mode == 'debut') c.debut = time;
    if (mode == 'fin') c.fin = time;

    if (mode == 'debut' && c.debut < c.min) c.debut = c.min;
    if (mode == 'fin' && c.fin > c.max) c.fin = c.max;
  }

  getLabel(n: number): string {
    return Jours.getLabel(n);
  }

  isHorairesValid(): boolean {
    let tmp = true;
    this.planning.forEach(c => { if (c.debut > c.fin) tmp = false; });            
    return tmp;
  }
}